import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

export const InputField = (disabled?: boolean) => css`
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
  border: 2px solid ${Theme.color.disabled};

  font-size: ${Theme.rems(18)};
  padding: 14px 16px 14px 12px;
  color: ${Theme.color.text};

  letter-spacing: 0px;
  border-radius: 30px;
  text-align: center;

  position: relative;
  line-height: 28px;
  appearance: none;

  display: block;
  outline: none;
  height: 50px;
  width: 100%;

  ${disabled &&
  css`
    background-color: color: ${Theme.color.disabledBg};
    pointer-events: none;
    color: rgb(0 0 0);
  `}
`;

export const InputPlaceholder = () => css`
  color: ${Theme.color.disabled};
  font-size: ${Theme.rems(18)};

  text-align: center;
  line-height: 28px;
`;

type FieldContainerAttributes = {
  last?: boolean;
  width: number;
};

export const FieldContainer = styled.div(
  ({ width, last }: FieldContainerAttributes) => css`
    margin-bottom: 8px;
    position: relative;

    width: ${width}%;
    display: block;

    ${last &&
    css`
      margin-bottom: 0;
    `}
  `
);

export const FieldLabel = styled.label`
  font-size: ${Theme.rems(16)};
  color: ${Theme.color.text};

  margin-bottom: 2px;
  position: relative;
  line-height: 140%;

  display: block;
  width: 100%;
`;

export const FieldInput = styled.input(
  ({ disabled }) => css`
    ${InputField(disabled)}

    ::placeholder {
      ${InputPlaceholder()}
    }
  `
);

type FieldErrorAttributes = {
  margin?: number | string;
};

export const FieldError = styled.span(
  ({ margin = 5 }: FieldErrorAttributes) => css`
    margin-top: ${margin}px;
    font-size: 0.875rem;

    color: rgb(191 0 0);
    position: relative;
    line-height: 1rem;

    display: block;
    width: 100%;
  `
);
